
import { addClass, removeClass, toggleClass, waitForFrame } from '../utility-functions/utility-functions';
import { fireEventWithData } from '../utility-functions/async-event-assets';

const CCC_ACTIVE_CLASS: string[] = ['is-active'];
const CCC_VISIBLE_CLASS:string[] = ['is-visible'];

export const activate = (elm: HTMLElement) => {
    if (!elm) return;
    addClass(elm, CCC_VISIBLE_CLASS);

    fireEventWithData({
        element: elm
    }, 'element.visible.activation', elm);

    return waitForFrame()
        .then(waitForFrame)
        .then(() => {
            return new Promise((resolve) => {
                const onTransitionEndActivate = (event:TransitionEvent) => {
                    elm.removeEventListener('transitionend', onTransitionEndActivate);
                    resolve(elm);
                };
                elm.addEventListener('transitionend', onTransitionEndActivate);
                addClass(elm, CCC_ACTIVE_CLASS);
            });
        });
};


export const deactivate = (elm:HTMLElement) => {
    if (!elm) return Promise.resolve(elm);

    // If it is already hidden
    if (!containsVisibleClass(elm) && !containsActiveClass(elm)) {
        return Promise.resolve();
    }

    // if `is-visible` has been removed before `is-active` for some reason
    if (!containsVisibleClass(elm) && containsActiveClass(elm)) {
        removeClass(elm, CCC_ACTIVE_CLASS);
        return Promise.resolve();
    }

    return new Promise(resolve => {
        const onTransitionEndDeactivate = () => {
            removeClass(elm, CCC_VISIBLE_CLASS);
            elm.removeEventListener('transitionend', onTransitionEndDeactivate);
            resolve(elm);
        };
        elm.addEventListener('transitionend', onTransitionEndDeactivate);
        removeClass(elm, CCC_ACTIVE_CLASS);
    });
};

export const visuallyDeactivate = elm => {
    if (!elm) return;

    return new Promise<void>(resolve => {
        const onTransitionEndDeactivate = () => {
            elm.removeEventListener('transitionend', onTransitionEndDeactivate);
            resolve();
        };
        elm.addEventListener('transitionend', onTransitionEndDeactivate);
        removeClass(elm, CCC_ACTIVE_CLASS);
    });

};

export const toggle = async (elm, isActive = false) => {
    if (elm.classList.contains(CCC_ACTIVE_CLASS && isActive === false)) {
        deactivate(elm);
        return;
    }
    activate(elm);
}; 


const containsVisibleClass = (elm: HTMLElement) => elm.classList.contains(CCC_VISIBLE_CLASS[0]);
const containsActiveClass = (elm: HTMLElement) => elm.classList.contains(CCC_ACTIVE_CLASS[0]);

window.activate = activate;
window.deactivate = deactivate;